import React, { useContext, useMemo } from 'react'
import { getYear } from 'date-fns'
import { capitalize } from '@mui/material'
import { getMonthsNames } from '../helpers'
import { DatePickerContext } from '../DatePickerProvider'
import { MonthButton, MonthContainer, MonthTypography } from './Month.styles'
import { useTranslation } from 'react-i18next'

export default function Month({ ...props }) {
  const {
    referenceDay,
    onChangeMonth,
    displayedMonth,
    locale,
    blockFutureDates,
    blockPastDates
  } = useContext(DatePickerContext)
  const { t } = useTranslation()

  const months = useMemo(() => getMonthsNames(locale, t), [locale, t])

  const isCurrentMonth = useMemo(() => {
    const today = new Date()
    return today.getMonth() === referenceDay.getMonth() &&
      today.getFullYear() === referenceDay.getFullYear()
  }, [referenceDay])

  const isNextMonthDisabled = blockFutureDates && isCurrentMonth
  const isPrevMonthDisabled = blockPastDates && isCurrentMonth

  return (
    <MonthContainer {...props}>
      <MonthButton
        onClick={() => onChangeMonth(-1)}
        color="secondary"
        size="small"
        width="20px"
        disabled={isPrevMonthDisabled}
      >
        <i className={'fa-light fa-angle-left'} />
      </MonthButton>

      <MonthTypography>
        {capitalize(months[displayedMonth])} {getYear(referenceDay)}
      </MonthTypography>

      <MonthButton
        onClick={() => onChangeMonth(1)}
        color="secondary"
        size="small"
        width="20px"
        disabled={isNextMonthDisabled}
      >
        <i className={'fa-light fa-angle-right'} />
      </MonthButton>
    </MonthContainer>
  )
}
